/* Good Gut Daily PDP (Arm B) — interaction layer.
   No-flash personalization + first-paint price handled WITHOUT this file
   (head CSS-vars + native ?variant=). This is progressive enhancement only:
   plan selection, subscribe toggle, per-day, gallery, sticky, ATC form sync. */
(function () {
  "use strict";
  var cfg = window.__ggd || {};
  var state = { variantId: null, mode: "sub" };

  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function money(cents) { return "$" + (cents / 100).toFixed(2); }

  // ── Plan (size) selection — updates ATC form hidden input ──
  function selectVariant(id) {
    if (!id) return;
    state.variantId = id;
    $all("[data-plan]").forEach(function (b) {
      var isSel = b.getAttribute("data-variant-id") === id;
      b.classList.toggle("is-active", isSel);
    });
    // Sync ATC form id input (native /cart/add submit)
    var atcInput = $("[data-atc-id]");
    if (atcInput) atcInput.value = id;
    syncPrice();
    updatePerDay();
    updateChewsTick(id);
    pushVariantToUrl(id);
  }

  // Mirror the selected size's subscribe price into plan-toggle header + per-day.
  function syncPrice() {
    var btn = $('[data-plan][data-variant-id="' + state.variantId + '"]');
    if (!btn) return;
    var base = parseInt(btn.getAttribute("data-price"), 10) || 0;
    var compare = parseInt(btn.getAttribute("data-compare"), 10) || 0;
    var sub = parseInt(btn.getAttribute("data-sub-price"), 10) || 0;
    var subText, wasText, otpCents;
    if (sub > 0) {
      // Recharge selling-plan product: sub price = the allocation; base = the
      // regular/strikethrough price; one-time pays the base.
      subText = money(sub);
      wasText = base > sub ? money(base) : "";
      otpCents = compare > base ? compare : base;
    } else {
      // Legacy: variant price IS the sub price; OTP derived from compare or ×1.25.
      subText = money(base);
      wasText = compare > base ? money(compare) : "";
      otpCents = compare > base ? compare : Math.round(base * 1.25);
    }
    $all("[data-price-now]").forEach(function (el) { el.textContent = subText; });
    $all("[data-price-was]").forEach(function (el) {
      el.textContent = wasText;
      el.style.display = wasText ? "" : "none";
    });
    $all("[data-otp-price]").forEach(function (el) { el.textContent = money(otpCents); });
  }

  function updatePerDay() {
    var btn = $('[data-plan][data-variant-id="' + state.variantId + '"]');
    var perdayEl = $("[data-perday]");
    if (!btn || !perdayEl) return;
    var sub = parseInt(btn.getAttribute("data-sub-price"), 10) || 0;
    var cents = sub > 0 ? sub : (parseInt(btn.getAttribute("data-price"), 10) || 0);
    var perday = (cents / 100 / 30);
    // Subscribe card always shows per-day — OTP card has its own static copy in HTML
    perdayEl.textContent = "≈ $" + perday.toFixed(2) + "/day · cancel anytime";
  }

  function updateChewsTick(id) {
    var btn = $('[data-plan][data-variant-id="' + id + '"]');
    if (!btn) return;
    var chews = parseInt(btn.getAttribute("data-chews"), 10) || 1;
    // Update ALL chews-display spans on page (buy box + routine section)
    $all("[data-chews-display]").forEach(function (el) { el.textContent = chews; });
    $all("[data-chews-plural]").forEach(function (el) { el.textContent = chews > 1 ? "s" : ""; });
  }

  // ── Subscribe / One-time toggle ──
  function setMode(mode) {
    state.mode = mode;
    $all("[data-subtoggle] [data-mode]").forEach(function (b) {
      b.classList.toggle("is-active", b.getAttribute("data-mode") === mode);
      // Update radio state inside each plan toggle card
      var radio = b.querySelector(".plan-opt__radio, .plan-toggle__radio");
      if (radio) radio.classList.toggle("is-sel", b.getAttribute("data-mode") === mode);
    });
    // If Shopify selling plan exists, write/clear it in the ATC form
    var planInput = $("[data-atc-plan]");
    if (planInput) {
      planInput.value = (mode === "sub" && cfg.sellingPlanId) ? cfg.sellingPlanId : "";
    }
    updatePerDay();
  }

  // ── Populate per-day text inside each size card on init ──
  function initPerDay() {
    $all("[data-plan]").forEach(function (btn, i) {
      var metaEl = btn.querySelector("[data-sizeperday-" + i + "]");
      if (!metaEl) return;
      var cents = parseInt(btn.getAttribute("data-price"), 10) || 0;
      var chews = parseInt(btn.getAttribute("data-chews"), 10) || (i + 1);
      var perday = cents / 100 / 30;
      metaEl.textContent = chews + " chew" + (chews > 1 ? "s" : "") + "/day · ~$" + perday.toFixed(2) + "/day";
    });
  }

  // Push selected variant to URL (keeps share links accurate)
  function pushVariantToUrl(id) {
    try {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", id);
      window.history.replaceState({}, "", url.toString());
    } catch (e) {}
  }

  // ── Gallery: big image + thumbnail strip ──
  function initGallery() {
    var track = $("[data-gallery-track]"), thumbs = $("[data-gallery-thumbs]");
    if (!track) return;
    var slides = $all(".media__slide", track);
    if (slides.length < 2) return;
    function setActive(i) {
      $all(".media__thumb", thumbs).forEach(function (t, ti) {
        t.classList.toggle("is-active", ti === i);
      });
    }
    if (thumbs) {
      $all(".media__thumb", thumbs).forEach(function (t, i) {
        t.addEventListener("click", function () {
          var slide = slides[i];
          if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: "smooth" });
          setActive(i);
        });
      });
    }
    track.addEventListener("scroll", function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      setActive(i);
    }, { passive: true });
  }

  // ── Sticky CTA: show after buy box scrolls out of view ──
  //    Click → smooth-scroll BACK to buy box (not a drawer).
  function initSticky() {
    var sticky = $("[data-sticky]"), anchor = $("#buy-box");
    if (!sticky || !("IntersectionObserver" in window)) return;
    var armed = false;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) armed = true;
        sticky.classList.toggle("is-on", armed && !e.isIntersecting);
      });
    }, { rootMargin: "0px 0px -10% 0px" }).observe(anchor || sticky);
  }

  // ── ATC → direct to checkout (bypass cart page) ──
  var form = document.getElementById("product-form");
  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = form.querySelector("[data-atc]");
      if (btn) { btn.disabled = true; btn.style.opacity = "0.7"; }
      var data = new FormData(form);
      fetch("/cart/add.js", { method: "POST", body: data })
        .then(function () { window.location.href = "/checkout"; })
        .catch(function () { if (btn) { btn.disabled = false; btn.style.opacity = ""; } });
    });
  }

  // Re-enable the ATC button on back/bfcache restore — it gets disabled during
  // the direct-to-checkout hop, and would otherwise stay greyed out on return.
  window.addEventListener("pageshow", function () {
    var b = document.querySelector("[data-atc]");
    if (b) { b.disabled = false; b.style.opacity = ""; }
  });

  // ── Wire up ──
  document.addEventListener("click", function (e) {
    // Size option selection
    var plan = e.target.closest("[data-plan]");
    if (plan) { selectVariant(plan.getAttribute("data-variant-id")); return; }

    // Plan toggle (subscribe / one-time)
    var modeBtn = e.target.closest("[data-subtoggle] [data-mode]");
    if (modeBtn) { setMode(modeBtn.getAttribute("data-mode")); return; }

    // Sticky CTA scrolls to the selector (not the top of the hero)
    if (e.target.closest("[data-scroll-buybox]")) {
      var target = $("#selector-anchor") || $("#buy-box");
      if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }
  });

  // ── Init ──
  function init() {
    var first = $("[data-plan].is-active") || $("[data-plan]");
    if (first) selectVariant(first.getAttribute("data-variant-id"));
    setMode("sub");
    initPerDay();
    initGallery();
    initSticky();
  }
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();
